/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useRef as r,useEffect as t}from"react";import{microTask as e}from"../utils/micro-task.js";import{useEvent as o}from"./use-event.js";function s(s){let n=o(s),m=r(!1);t((()=>(m.current=!1,()=>{m.current=!0,e((()=>{m.current&&n()}))})),[n])}export{s as useOnUnmount};
//# sourceMappingURL=use-on-unmount.js.map
